import Parse from "parse";
import type { Page } from "./Page";

export type BlockType =
  | "hero"
  | "text"
  | "richtext"
  | "html"
  | "image"
  | "gallery"
  | "cards"
  | "tabs-header"
  | "tabs"
  | "accordion"
  | "infobox"
  | "video"
  | "interactive"
  | "chart"
  | "table"
  | "section"
  | "navigation"
  | "content-card"
  | "sources"
  | "custom";

export interface BlockConfig {
  [key: string]: any;
}

export interface BlockAttributes {
  objectId: string;
  createdAt: Date;
  updatedAt: Date;

  tenant: Parse.Object;
  page: Page;

  order: number;
  blockType: BlockType;

  title_de?: string;
  title_en?: string;

  config?: BlockConfig;

  backgroundColor?: string;
  padding?: string;
  marginBottom?: string;
  customCss?: string;

  tabGroup?: string;
  tabId?: string;
  tabOrder?: number;

  isActive?: boolean;
}

export class Block extends Parse.Object<BlockAttributes> {
  static className = "APP_Block";

  constructor(data?: Partial<BlockAttributes>) {
    super("APP_Block", data as BlockAttributes);
  }

  get order(): number {
    return this.get("order") ?? 0;
  }

  get blockType(): BlockType {
    return this.get("blockType") || "text";
  }

  get title_de(): string | undefined {
    return this.get("title_de");
  }

  get title_en(): string | undefined {
    return this.get("title_en");
  }

  get config(): BlockConfig {
    return this.get("config") || {};
  }

  get backgroundColor(): string | undefined {
    return this.get("backgroundColor");
  }

  get tabGroup(): string | undefined {
    return this.get("tabGroup");
  }

  get tabId(): string | undefined {
    return this.get("tabId");
  }

  get tabOrder(): number | undefined {
    return this.get("tabOrder");
  }

  get isActive(): boolean {
    return this.get("isActive") ?? true;
  }
}

Parse.Object.registerSubclass("APP_Block", Block);
